var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FEC722"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 9.625H12.25C10 9.625 8.5 10.75 8.5 13.375V18.625C8.5 21.25 10 22.375 12.25 22.375H19.75C22 22.375 23.5 21.25 23.5 18.625V13.375C23.5 10.75 22 9.625 19.75 9.625ZM20.1025 14.1925L17.755 16.0675C17.26 16.465 16.63 16.66 16 16.66C15.37 16.66 14.7325 16.465 14.245 16.0675L11.8975 14.1925C11.6575 13.9975 11.62 13.6375 11.8075 13.3975C12.0025 13.1575 12.355 13.1125 12.595 13.3075L14.9425 15.1825C15.5125 15.64 16.48 15.64 17.05 15.1825L19.3975 13.3075C19.6375 13.1125 19.9975 13.15 20.185 13.3975C20.38 13.6375 20.3425 13.9975 20.1025 14.1925Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.f83a9cf1db918403afc90c64027301b0.svg";
export { ForwardRef as ReactComponent };